/* eslint-disable @typescript-eslint/no-var-requires */
//TODO: pasar de required a imports
/**
 *
 * This configuration file contains what is related
 * to environment variables. For that it is necessary
 * to have the corresponding .env.xxxx files (Ex: .env.development, etc)
 *
 */

/* eslint-disable global-require */
import defaultConfig from './default'

export type ENVs = 'dev' | 'stg' | 'prd' | 'local'
export interface Config {
  basePath: string
  basename: string
  routerPath: string
  env: ENVs
  api: {
    url: string
  }
}

declare global {
  interface Window {
    NP_MODE_SCOPE: string
  }
}

let config = { ...defaultConfig }

if (window.NP_MODE_SCOPE === 'stg') {
  config = { ...config, ...require('./stg').default }
}

if (window.NP_MODE_SCOPE === 'prd') {
  config = { ...config, ...require('./prd').default }
}

if (window.NP_MODE_SCOPE === 'local') {
  config = { ...config, ...require('./local').default }
}

if (window.NP_MODE_SCOPE === 'dev') {
  config = { ...config, ...require('./dev').default }
}

export default config
